<template>
  <div>
    <p v-if="msTime.show">
      <span v-if="msTime.day>0"><span>{{ msTime.day }}</span><i>{{ dayTxt }}</i></span>
      <span>{{ msTime.hour }}</span><i>{{ hourTxt }}</i>
      <span>{{ msTime.minutes }}</span><i>{{ minutesTxt }}</i>
      <span>{{ msTime.seconds }}</span><i>{{ secondsTxt }}</i>
    </p>
  </div>
</template>
<script>
export default {
  replace: true,
  data() {
    return {
      tipShow: true,
      msTime: {			// 倒计时数值
        show: false,		// 倒计时状态
        day: '',			// 天
        hour: '',		// 小时
        minutes: '',		// 分钟
        seconds: ''		// 秒
      },
      star: ''			// 活动开始时间
    };
  },
  props: {
    // 距离开始提示文字
    tipText: {
      type: String,
      default: '距离开始'
    },
    // 距离结束提示文字
    tipTextEnd: {
      type: String,
      default: '距离结束'
    },
    // 时间控件ID
    id: {
      type: String,
      default: '1'
    },
    // 活动开始时间
    startTime: {
      type: Number,
      required: true
    },
    // 倒计时结束显示文本
    endText: {
      type: String,
      default: '已结束'
    },
    // 自定义显示文字:天
    dayTxt: {
      type: String,
      default: ':'
    },
    // 自定义显示文字:时
    hourTxt: {
      type: String,
      default: ':'
    },
    // 自定义显示文字:分
    minutesTxt: {
      type: String,
      default: ':'
    },
    secondsTxt: {
      type: String,
      default: ':'
    },
    // 是否开启秒表倒计，未完成
    secondsFixed: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log(this);
    this.gogogo();
  },
  methods: {
    gogogo: function() {
      // 判断是秒还是毫秒
      this.startTime.toString().length === 10 ? this.star = this.startTime * 1000 : this.star = this.startTime;
      this.msTime.show = true;
      this.start_message();
    },
    runTime(endTime, callFun, type) {
      const msTime = this.msTime;
      const currentTime = Date.now();
      let timeDistance = currentTime - endTime;
      if (timeDistance > 0) {
        this.msTime.show = true;
        msTime.day = Math.floor(timeDistance / 86400000);
        timeDistance -= msTime.day * 86400000;
        msTime.hour = Math.floor(timeDistance / 3600000);
        timeDistance -= msTime.hour * 3600000;
        msTime.minutes = Math.floor(timeDistance / 60000);
        timeDistance -= msTime.minutes * 60000;
        // 是否开启秒表倒计,未完成
        //                    this.secondsFixed ? msTime.seconds = new Number(timeDistance / 1000).toFixed(2) : msTime.seconds = Math.floor( timeDistance / 1000 ).toFixed(0);
        msTime.seconds = Math.floor(timeDistance / 1000).toFixed(0);
        timeDistance -= msTime.seconds * 1000;

        if (msTime.hour < 10) {
          msTime.hour = '0' + msTime.hour;
        }
        if (msTime.minutes < 10) {
          msTime.minutes = '0' + msTime.minutes;
        }
        if (msTime.seconds < 10) {
          msTime.seconds = '0' + msTime.seconds;
        }
        const _s = Date.now();
        const _e = Date.now();
        const diffPerFunc = _e - _s;
        setTimeout(() => {
          if (type) {
            this.runTime(endTime, callFun, true);
          } else {
            this.runTime(endTime, callFun);
          }
        }, 1000 - diffPerFunc);
      } else {
        callFun();
      }
    },
    start_message() {
      setTimeout(() => {
        this.runTime(this.star, this.end_message, true);
      }, 1);
    },
    end_message() {
      this.msTime.show = false;
    }
  }
};
</script>
